import { UpdateAddressRequest } from '@src/main/modules/messages/infrastructure/dto/updateAddressRequest';
import { createAddressHttpRepository } from '@src/main/modules/messages/infrastructure/repository/AddressHttpRepository';
import { TokenProvider } from '@src/main/shared/infrastructure/entity/axios';

export const updateAddressUseCase = async (
  data: UpdateAddressRequest,
  tokenProvider: TokenProvider,
) => {
  const repository = createAddressHttpRepository(tokenProvider);
  return await repository.update(data);
};
